import React from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import { User } from '../../../../models/interfaces/User.interface';
import { BusinessObject } from '../../../../models/interfaces/BusinessObject.interface';
import { ProductCategory } from '../../../../models/interfaces/ProductCategory.interface';
import CategoryInfoCardComponent from '../category-context/components/category-info-card/category-info-card.component';

export default function ProductContextComponent() {
  const { user, businessObject, category } = useOutletContext<{
    user: User;
    businessObject: BusinessObject;
    category: ProductCategory;
  }>();

  return (
    <>
      <CategoryInfoCardComponent category={category}></CategoryInfoCardComponent>
      <Outlet context={{ user, businessObject, category }} />
    </>
  );
}
